import React, { createContext, useContext, useState, useCallback } from 'react';
import translations from '@/i18n/translations';

const LanguageContext = createContext(null);

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    try {
      return localStorage.getItem('bmpay_lang') || 'fr';
    } catch {
      return 'fr';
    }
  });

  const changeLanguage = useCallback((lang) => {
    setLanguage(lang);
    try {
      localStorage.setItem('bmpay_lang', lang);
    } catch {}
  }, []);

  const t = useCallback((key) => {
    return translations[language]?.[key] || translations.fr?.[key] || key;
  }, [language]);

  return (
    <LanguageContext.Provider value={{ language, changeLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};
